export default "__VITE_PUBLIC_ASSET__77f14da3__"